import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const withLogged = (Component) => {
    return (props) => {
        const loggedIn = useSelector(({ auth }) => auth.login.loggedIn);

        if (loggedIn) {
            return <Navigate to="/mabaa010" replace />;
        }

        return <Component {...props} />;
    };
};
export default withLogged;
